import { Alert, Body, Box, Heading, Paper, Spinner, Stack } from '@lanekassen/ui';
import { HtmlString } from '@modulis/utils';
import purify from 'dompurify';
import { useForsideteksterContext } from '../context/useForsideteksterContext';
import SigneringsStatusMelding from '../components/SigneringsStatusMelding';
import ForsideAvtaler from '../components/ForsideAvtaler';
import { useHentAvtalerQuery } from '../hooks/queries';

function Forside() {
  const forsideTekster = useForsideteksterContext();
  const { data: foreldresigneringState, isLoading, isError, refetch: hentAvtalerPaNytt } = useHentAvtalerQuery();

  const fikkTekniskFeil = isError || foreldresigneringState?.harTjenesteFeilet;

  if (isLoading) {
    return <Spinner />;
  }

  const harIngenAvtaler =
    !foreldresigneringState?.agreementsForSigning?.length && !foreldresigneringState?.signedAgreements?.length;

  return (
    <Box>
      <Heading
        textAlign="center"
        level={1}
        padding={4}
        // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{
          __html: purify.sanitize(forsideTekster.sidetittel, { ALLOWED_TAGS: [] }),
        }}
      />
      <Paper sx={{ padding: 4, maxWidth: '596px', marginX: 'auto' }}>
        <Stack spacing={2}>
          {forsideTekster.globalNotabenemelding?.value && (
            <Alert severity="info">
              <HtmlString value={forsideTekster.globalNotabenemelding} />
            </Alert>
          )}
          {forsideTekster.globalFeilmelding?.value && (
            <Alert severity="error">
              <HtmlString value={forsideTekster.globalFeilmelding} />
            </Alert>
          )}
          <SigneringsStatusMelding
            refreshInnhold={async () => {
              await hentAvtalerPaNytt();
            }}
          />
          <Body>{forsideTekster?.signeringUndertittel}</Body>
          {/* <Box border={"1px solid blue"} height="60px" paddingLeft={8} alignContent={"center"}>
              Det er en nyere avtale til signering.
            </Box> */}
          {}
          {harIngenAvtaler && !fikkTekniskFeil ? (
            <>
              <Body marginTop={2} isBold>
                {forsideTekster?.tittelIngenAvtaler}
              </Body>
              <HtmlString value={forsideTekster?.tekstIngenAvtaler} />
            </>
          ) : (
            <ForsideAvtaler
              fikkTekniskFeil={fikkTekniskFeil ?? false}
              foreldresigneringState={foreldresigneringState}
            />
          )}
        </Stack>
      </Paper>
    </Box>
  );
}

export default Forside;
